import '@cognitoforms/styles/global/notifications.scss';
import { MessageBox } from '@cognitoforms/element-ui';

export default function(confirmOptions) {
	return MessageBox({
		title: confirmOptions.title ?? null,
		showClose: confirmOptions.showClose ?? false,
		message: confirmOptions.message,
		showConfirmButton: confirmOptions.showConfirmButton ?? true,
		showCancelButton: true,
		confirmButtonText: confirmOptions.confirmButtonText ?? 'Yes',
		cancelButtonText: confirmOptions.cancelButtonText ?? 'No',
		cancelButtonClass: confirmOptions.cancelButtonClass ?? (confirmOptions.isLegacy ? 'c-modal-button c-modal-button-cancel' : 'button button--secondary sz-2'),
		confirmButtonClass: confirmOptions.confirmButtonClass ?? (confirmOptions.isLegacy ? 'c-modal-button' : 'button button--no-style bg-deep white sz-2 px-2 py-1'),
		customClass: confirmOptions.customClass ?? 'notification notification--message'
	});
}